<template>
  <div class="container">

    <div v-if="(isindex&&name)||!isindex">
      <h1 class="title_font">{{name == "Products" ? $t('productList.products') : name}}</h1>
      <v-line></v-line>
      <div v-if="description" v-html="description" style="overflow:hidden;"></div>
    </div>
    <div v-if="this.products.data?this.products.data.length:this.products.length">
      <v-commoditylistitem
        v-for="(item,index) in commoditylist"
        :key="index"
        :products="item"
        :collectionsslug="collectionsslug"
        :index="index"
        :layout="layout"
      ></v-commoditylistitem>
      <div class="paging" v-if="this.products.total/this.products.per_page>1 && !this.isindex ">
        <el-pagination
          :small="small"
          :pager-count="5"
          :page-size="this.products.per_page"
          :current-page="this.products.current_page"
          layout="prev, pager, next"
          :total="this.products.total"
          @current-change="page"
        ></el-pagination>
      </div>
    </div>
    <div v-else-if="!this.isindex">{{$t('productList.no_products')}}</div>
    <v-noproduct v-else :layout="layout"></v-noproduct>
  </div>
</template>
<script>

export default {
  props: [
    "products",
    "name",
    "collectionsslug",
    "isindex",
    "layout",
    "description"
  ],
  data() {
    return {
      commoditylist: [],
      small: false,
    };
  },
  methods: {
    page(e) {
      window.open(this.products.path + "?page=" + e, "_self");
    },
  },
  mounted() {
    this.small = this.$(window).width() <= 575;
    console.log("分割前分类产品", this.products);
    //首页传来的商品是没有data字段的所以直接分割
    if (this.products.data) {
      for (let i = 0; i < this.products.data.length; i += 3) {
        this.commoditylist.push(this.products.data.slice(i, i + 3));
      }
    } else {
      for (let i = 0; i < this.products.length; i += 3) {
        this.commoditylist.push(this.products.slice(i, i + 3));
      }

      console.log(this.commoditylist);
    }
  }
};
</script>
<style scoped lang='scss'>
.container {
  text-align: center;

  h1 {
    margin-top: 16px;
    font-size: 26px;
  }
}
</style>